import { render, staticRenderFns } from "./weChatPayQRcode.vue?vue&type=template&id=fbfbc37c&"
import script from "./weChatPayQRcode.vue?vue&type=script&lang=js&"
export * from "./weChatPayQRcode.vue?vue&type=script&lang=js&"
import style0 from "./weChatPayQRcode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports